import { useLocation, useNavigate, useParams, Navigate } from 'react-router-dom';

/**
 * Utilidades para manejo de rutas (versión modernizada)
 */


// Helper para withRouter - React Router v6 no tiene withRouter nativo
export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    
    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        params={params}
      />
    );
  };
  
  return Wrapper;
};

// Exportar Navigate para uso directo
export { Navigate };
